import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export function useOrigin() {
  const query = useQuery()
  const from = query.get('from')
  useEffect(
    () => {
      if (from) {
        const date = new Date()
        localStorage.setItem('origin', from)
        localStorage.setItem(
          'originExpiry',
          date.getTime() + 6 * 60 * 60 * 1000
        ) // 6 hours from now
      } else {
        localStorage.removeItem('origin')
        localStorage.removeItem('originExpiry')
      }
    },
    [from]
  )

  const origin = localStorage.getItem('origin')
  const originExpiry = localStorage.getItem('originExpiry')
  if (!origin || !originExpiry) {
    return null
  }

  const now = new Date()

  if (now.getTime() > originExpiry) {
    localStorage.removeItem('origin')
    localStorage.removeItem('originExpiry')
    return null
  }

  return origin
}
